import ShiftUpdateAlertCard from './shift-update-alert-card'

export default ShiftUpdateAlertCard
